import MuiTextField from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import { border } from '@topconagriculture/theme';
import classNames from 'classnames';
import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import { FontIcon } from '../../FontIcon';
const styles = (theme) => createStyles({
    search: {
        position: 'relative',
        width: '100%',
        borderRadius: theme.common.borderRadius.default,
        height: 40,
        minWidth: 100,
    },
    root: {
        height: 40,
        position: 'absolute',
        border: border(theme.color.grey.light),
        borderRadius: theme.common.borderRadius.default,
        width: '100%',
        backgroundColor: theme.color.background.light,
    },
    inputTextFilter: {
        padding: '12px 0',
        paddingLeft: 10,
        paddingRight: 50,
        color: theme.color.grey.dark,
        fontSize: '0.75rem',
        '&:after, &:before': {
            content: 'none',
        },
        '&::-webkit-input-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&::-moz-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&:-ms-input-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&:-moz-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
    },
    inputDisabled: {
        backgroundColor: theme.color.grey.lightest,
        cursor: 'default',
        pointerEvents: 'none',
    },
    buttonSearch: {
        position: 'absolute',
        borderRadius: '0 5px 5px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        top: 0,
        width: 40,
        height: 40,
        color: theme.color.font.light,
        backgroundColor: theme.color.primary.main,
        textAlign: 'center',
        '&:hover': {
            backgroundColor: theme.color.primary.dark,
            cursor: 'pointer',
        },
        '&:active': {
            backgroundColor: theme.color.primary.darkest,
            cursor: 'pointer',
        },
    },
    buttonSearchDisabled: {
        backgroundColor: theme.color.grey.light,
        cursor: 'default',
        pointerEvents: 'none',
    },
    buttonIcon: {
        color: theme.color.font.light,
        fontSize: 20,
        position: 'relative',
    },
});
const SearchInput = (props) => {
    const { classes, resetField, handleChange, className, InputLabelProps: InputLabelProperties = {}, InputProps: InputProperties = {}, input: { onChange, ...inputProps }, disabled, testId = 'SearchInput', ...others } = props;
    const currentIcon = props.input.value.length > 0 ? 'close' : 'search';
    return (React.createElement("div", { className: classes.search, "data-testid": `${testId}` },
        React.createElement(MuiTextField, Object.assign({}, inputProps, others, { disabled: disabled, InputProps: { inputProps: { className: classes.inputTextFilter }, disableUnderline: true }, className: classNames(classes.root, className, disabled && classes.inputDisabled), onChange: (e) => handleChange(e.target.value), "data-testid": `${testId}-input` })),
        React.createElement("div", { "data-testid": `${testId}-reset`, className: classNames(classes.buttonSearch, disabled && classes.buttonSearchDisabled), onClick: resetField },
            React.createElement(FontIcon, { size: 20, iconName: currentIcon }))));
};
const ComposedSearchInput = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleChange: (props) => (val) => {
        props.input.onChange(val);
    },
    resetField: (props) => () => {
        props.input.onChange('');
    },
}))(SearchInput);
ComposedSearchInput.displayName = 'SearchInput';
export default ComposedSearchInput;
//# sourceMappingURL=SearchInput.js.map